import React, { useState } from "react";
import titleBackground from "../../assets/images/pk-events/titleBackground.png";
import RewardBackground from "../../assets/images/pk-events/RewardBackground.png";
import activeTabBar from "../../assets/images/pk-events/btn 3.png";
import tabBar from "../../assets/images/pk-events/inactove 1.png";
import fallbackImage2 from "../../assets/icons/gift-box 1.png";
import close from "../../assets/images/pk-events/close1.png";
import { useTranslation } from "react-i18next";

const RewardDialog = ({ isOpen, onClose, rewardData }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("tab1");
  const [imageErrors, setImageErrors] = useState({});
  const [imageErrors1, setImageErrors1] = useState({});
  const imageBaseUrl = "https://media.smolivechat.com/";

  const handleError = (itemId) => {
    setImageErrors((prev) => ({ ...prev, [itemId]: true }));
  };
  const handleError1 = (imagePath) => {
    setImageErrors1((prevState) => ({
      ...prevState,
      [imagePath]: true, // mark this path as failed
    }));
  };
  const renderRewards = (topDetails) => {
    if (!topDetails) return null;

    return (
      <div className=" tab-panel w-full">
        <div className="pt-2 overflow-hidden relative flex flex-col items-center text-center">
          <div className="h-[70vh] overflow-y-auto w-full mx-auto">
            {[
              { title: t("First place reward"), rewards: topDetails?.top_1 },
              { title: t("Second place reward"), rewards: topDetails?.top_2 },
              { title: t("Third place reward"), rewards: topDetails?.top_3 },
            ].map((section, sectionIndex) => (
              <div key={sectionIndex} className="w-full mb-8">
                {/* Title Background */}
                <div className="relative w-[60%] mx-auto mb-4">
                  <img
                    src={titleBackground}
                    alt={`${section.title} background`}
                    className="w-full h-auto object-cover rounded-lg"
                  />
                  <p className="absolute top-[-8px] inset-0 flex items-center justify-center font-cairo font-medium text-[16px] leading-[19px] text-center text-[#E9C554]">
                    {section.title}
                  </p>
                </div>

                {/* Rewards List */}
                <div className="rounded-2xl p-2 relative my-3">
                  <div className="flex flex-wrap justify-center items-center gap-4">
                    {section.rewards?.length > 0 ? (
                      section.rewards.map((item, index) => (
                        <div
                          key={`${item.name}-${index}`}
                          className="rounded-2xl w-[100px] h-[105px] flex flex-col items-center"
                        >
                          <div className="relative flex flex-col items-center gap-2 justify-center">
                            <img
                              src={RewardBackground}
                              alt="reward background"
                              className="  rounded-2xl"
                            />
                            <img
                              src={
                                imageErrors1[item?.image]
                                  ? fallbackImage2
                                  : `${imageBaseUrl}${item?.image}`
                              }
                              alt={item.name}
                              onError={() => handleError1(item?.image)}
                              className="absolute inset-0  top-[-21px] m-auto rounded-full w-[55px] h-[55px] object-cover shadow-md"
                            />
                            <p className="text-[9px]   w-[100px] truncate  text-center font-cairo font-bold gradientText  ">
                              {item.name}
                            </p>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-xs font-medium text-white py-3">
                        {t("no data available")}
                      </p>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  };

  const tabs = [
    {
      id: "tab1",
      label: "PK King",
      imgActive: activeTabBar,
      imgInactive: tabBar,
    },
    {
      id: "tab2",
      label: "PK Room",
      imgActive: activeTabBar,
      imgInactive: tabBar,
    },
    {
      id: "tab3",
      label: "PK Star",
      imgActive: activeTabBar,
      imgInactive: tabBar,
    },
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[999999]">
      {/* Dialog box */}
      <div className="relative  pkRewardBackGround pt-24  rounded-2xl p-4 w-[95%] md:w-[80%] lg:w-[60%] max-h-[90vh]  ">
        {/* Close button */}
        <p className="absolute top-[67px]    gradientTextRules left-1/2 w-full p-4 z-40 transform -translate-x-1/2 text-[20px] leading-none tracking-normal font-semibold text-center">
          {t("Rewards")}
        </p>
        <button
          onClick={onClose}
          className="absolute top-[41rem] z-50 right-[46%]"
        >
          <img src={close} alt="close" className="w-8" />
        </button>

        {/* Tab Bar */}
        <div className="flex relative w-full mx-auto gap-2 justify-center mt-10 mb-2 px-4">
          {tabs.map((tab) => (
            <div
              key={tab.id}
              className="relative w-[32%] flex flex-row cursor-pointer"
              onClick={() => setActiveTab(tab.id)}
            >
              <img
                src={activeTab === tab.id ? tab.imgActive : tab.imgInactive}
                alt={tab.label}
                className=" h-[40px] "
              />
              <p
                className={`absolute py-2 w-full top-1/2
                left-[47%] transform -translate-x-1/2 -translate-y-1/2
                text-[16px] leading-none  tracking-normal text-center
                ${
                  activeTab === tab.id
                    ? "font-semibold gradientTextRules"
                    : "font-medium gradientTextMuted"
                }`}
              >
                {t(tab.label)}
              </p>
            </div>
          ))}
        </div>

        {/* Rewards Content */}
        <div className="min-h-0 flex-1 overflow-y-auto h-[70%] px-1 pb-5">
          {activeTab === "tab1" && renderRewards(rewardData?.pk_king)}
          {activeTab === "tab2" && renderRewards(rewardData?.pk_room)}
          {activeTab === "tab3" && renderRewards(rewardData?.pk_star)}
        </div>
      </div>
    </div>
  );
};

export default RewardDialog;
